var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"label label-warning d-inline-block mr-2 pl-2 pr-2 mb-0"},[_c('span',{staticClass:"mr-1"},[_vm._v("Port")]),_vm._l((_vm.checkedPort),function(port,index){return _c('span',{key:port},[_c('strong',[_vm._v(_vm._s(port))]),(index < _vm.checkedPort.length-1)?_c('span',[_vm._v(", ")]):_vm._e()])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }